var _path, _linearGradient, _path2, _linearGradient2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Hacksaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M33.5,30h-32c-0.176,0-0.343,0.06-0.5,0.153v4.694C1.157,34.94,1.324,35,1.5,35h32 c0.828,0,1.5-1.12,1.5-2.5C35,31.12,34.328,30,33.5,30z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "X3fFkQ~Kn4d297vXkAVY1a",
    x1: 17.5,
    x2: 17.5,
    y1: 19.553,
    y2: 37.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#X3fFkQ~Kn4d297vXkAVY1a)",
    d: "M1.502,35c-0.074,0-0.149-0.005-0.225-0.017c-0.819-0.123-1.384-0.887-1.261-1.706 l2.185-15.563C2.784,13.824,6.063,11,9.998,11H33.5c0.828,0,1.5,0.672,1.5,1.5S34.328,14,33.5,14H9.998 c-2.438,0-4.469,1.749-4.83,4.16L2.983,33.723C2.872,34.467,2.231,35,1.502,35z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "X3fFkQ~Kn4d297vXkAVY1b",
    x1: 39.395,
    x2: 39.395,
    y1: 14.575,
    y2: 31.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f44f5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e52030"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#X3fFkQ~Kn4d297vXkAVY1b)",
    d: "M46.18,12.801C46.078,11.779,45.218,11,44.19,11H31l2,24h12.79 c1.183,0,2.108-1.022,1.99-2.199L46.18,12.801z M38.372,32c-1.01,0-1.86-0.758-1.974-1.761l-1.145-14.026 C35.118,15.033,36.04,14,37.227,14h0c1.01,0,1.86,0.758,1.974,1.761l1.145,14.026C40.481,30.967,39.559,32,38.372,32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Hacksaw);
export default __webpack_public_path__ + "static/media/icons8-hacksaw.94ec6fad157a826dc105d62b18e7a2f0.svg";
export { ForwardRef as ReactComponent };